import { ActivatedRoute } from '@angular/router';

export interface TerminalModule {
  terminalExit: null | undefined | 'protected';
}
